import {createAction} from '@reduxjs/toolkit';

export const setPreference = createAction('SETTINGS/SET_PREFERENCE');
